import { Component, Inject, OnInit } from '@angular/core';

import { AddExpenseEmployeeComponent } from '../../add-expense-employee/add-expense-employee.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { FormBuilder } from '@angular/forms';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { Config } from 'src/app/app-constant';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { forkJoin } from 'rxjs';
@Component({
  selector: 'app-add-dept-loc',
  templateUrl: './add-dept-loc.component.html',
  styleUrls: ['./add-dept-loc.component.scss'],
})
export class AddDeptLocComponent implements OnInit {


  locations: any[] = [
    'New York',
    'Los Angeles',
    'Chicago',
    'Houston',
    'Phoenix',
    'Philadelphia',
    'San Antonio',
    'San Diego',
    'Dallas',
    'San Jose'
  ];
  filterText: any = '';
  selectedDepartment: any;
  popupName: any;
  tableDataForDept: any = [];
  tableDataForLoca: any = [];
  loggedInUserCompanyID: any;
  loggedInUserRole: any;
  employeId: any;
  buttonColorName: any;
  setPrefix: any;
  setLimit: any;
  changeByUserId: any;
  year: any;
  editableIndex: any;
  updatetableDataForLoca: any;
  employeeDetails: any;
  fiscalYear: any
  loggedInUserId: any | null;
  subModuleButtonColor: any | null;
  loggedInCompanyFiscalyear: any | null;
  loggedInUserEmpCode: any | null;
  companyCodeId: any;
  yearForNewDept: any;
  DeptNewAddedrecord: any;
  constructor(

    private config: Config,
    public dialogRef: MatDialogRef<AddDeptLocComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog,
    private fb: FormBuilder, private httpService: HttpService,
    private loader: LoaderService, private encryptionService: EncryptionService,) {

    this.employeeDetails = data?.employeeData,
      this.popupName = data?.popupName;
    this.setPrefix = data.setPrefix;
    this.setLimit = data.setLimit;
    // companyId= this.loggedInUserCompanyID,
    this.changeByUserId = data.changeByUserId
    this.year = data.year
    this.fiscalYear = data.fiscalYear
    this.employeId = data.employeeData.id;

  }
  ngOnInit() {

    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.getDeptList();
    this.getLocationlist();

    this.httpService.employeeCodeData$.subscribe((data: any) => {
      console.log(data);
      this.yearForNewDept = data.year;
      this.companyCodeId = data.companyCodeId;

    });

  }
  onCheckIconView = false;
  isFormDisabled = false;
  editedIndividualScoreId: number | null = null;
  updatedListData: any = [];

  onClickEdit(i: any) {

    this.editableIndex = i;
    this.onCheckIconView = true;
    this.isFormDisabled = true;
  }
  onClickClose() {
    this.onCheckIconView = false;
    this.isFormDisabled = true;
    this.editableIndex = null
    this.getDeptList()
  }
  onClickCloseLocation(){
    this.onCheckIconView = false;
    this.isFormDisabled = true;
    this.editableIndex = null;
    this.getLocationlist();
   
  }
  arrAllDepartmentCode: any = [];
  deptrecord: any = []
  CombineDeptArray: any = []
  getDeptList() {

    const year = this.year ? this.year : this.yearForNewDept

    this.httpService.callGetService(`${this.config.getDepartmentListForELCM}?companyId=${this.loggedInUserCompanyID}&year=${year}`,).subscribe((resp: any) => {
      this.arrAllDepartmentCode = [];
      this.arrAllDepartmentCode = resp.data;

    })
    setTimeout(() => {

      this.httpService.callGetService(`${this.config.getDepartment}/${this.loggedInUserCompanyID}`).subscribe((record: any) => {
        console.log(this.popupName.label);
        if (this.popupName == 'addDept') {
          this.deptrecord = record.data;
          this.tableDataForDept = this.deptrecord.map((elm: any) => {
            const department = elm; // Ensure department is a valid any
            return {
              department: department, // Ensure the department is assigned properly
              deptCode: null, // Assign extracted two-letter code
              finalCode: null, // Assign extracted two-letter code
            };
          });
        } else {
          this.tableDataForDept = [{
            department: this.popupName.label, // Ensure the department is assigned properly
            deptCode: null, // Assign extracted two-letter code
            finalCode: null, // Assign extracted two-letter code
          }];

        }

        this.updatedListData = this.tableDataForDept?.map((dept: any) => {

          const deptNames = this.tableDataForDept?.map((d: any) => d.department) || []; // Extract department names from dept array

          // Filter departments that are in NotmatchingData but NOT in deptNames
          const data = this.arrAllDepartmentCode.filter((elm: any) => !deptNames.includes(elm.departmentName));

          this.DeptNewAddedrecord = data?.map((elm: any) => {
            return {
              department: elm?.departmentName, // Ensure the department is assigned properly
              deptCode: elm?.departmentPrefix, // Assign extracted two-letter code
              departmentId: elm?.departmentId,
            }

          })
          const matchingData = this.arrAllDepartmentCode?.find((data: any) => data?.departmentName === dept?.department);


          // Update the limit for the matching band or set it to null for non-matching bands
          return {
            ...dept,
            // department: matchingBand ? matchingBand.departmentName : null,

            departmentId: matchingData ? matchingData.departmentId : null,
            deptCode: matchingData ? matchingData.departmentPrefix : null,
            finalCode: matchingData ? matchingData.finalCode : null, // Use amountLimit if matching, otherwise null
          };
        });
        this.CombineDeptArray = [...this.updatedListData, ...this.DeptNewAddedrecord];

      })


    }, 100)
    // console.log(this.updatetableDataForLoca);

  }
  closepopup() {
    console.log(this.CombineDeptArray);
  
    // Find the first department with a null deptCode
    const invalidDept = this.CombineDeptArray.find((dept: any) => dept.deptCode == null);
  
    if (invalidDept) {
      this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: 'All department codes are required',
          btn2: 'OK',
          btn2BgColor: 'red', // Highlight error with red button color
          showSuccessIcon: false,
          showSuccessMessage: false
        }
      });
      return; // Stop execution
    }
  
    // Close all dialogs if no errors
    this.dialog.closeAll();
  }
 invalidLocation:any
  closeLocation() {
    // Find the first location with a null code
   this.invalidLocation = this.updatetableDataForLoca.find((loc: any) => loc.locationId == null);

  
    if (this.invalidLocation) {
      this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: 'All location codes are required',
          btn2: 'OK',
          btn2BgColor: 'red', // Highlight error with red button color
          showSuccessIcon: false,
          showSuccessMessage: false
        }
      });
      return; // Stop execution if an invalid location is found
    }
  
    // Close all dialogs if all locations have valid codes
    this.dialog.closeAll();
  }
  
  arrAllLocationList: any = [];
  getLocationListForPrifix() {



    this.httpService.callGetService(`${this.config.getLocationListForELCM}?companyId=${this.loggedInUserCompanyID}&year=${this.year}`,).subscribe((resp: any) => {
      this.arrAllLocationList = [];
      console.log(resp.data);

      this.arrAllLocationList = resp.data;

    })
    setTimeout(() => {



      this.updatetableDataForLoca = this.tableDataForLoca.map((elm: any) => {
        console.log(elm);
        console.log(this.arrAllLocationList);

        const matchLocation = this.arrAllLocationList.find((data: any) => data.locationName == elm.name);
        return {
          ...elm,
          locationId: matchLocation ? matchLocation.locationId : null,
          code: matchLocation ? matchLocation.locationPrefix : elm.code,
          finalCode: matchLocation ? matchLocation.finalCode : null,
        }
      })

      if(this.popupName=='addLoc'){
        this.saveLocation();
      }

    }, 200)
    console.log(this.updatetableDataForLoca);

  }
  getLocationlist() {
   
    const states = [
      { code: "AP", name: "Andhra Pradesh" },
      { code: "AR", name: "Arunachal Pradesh" },
      { code: "AS", name: "Assam" },
      { code: "BR", name: "Bihar" },
      { code: "CT", name: "Chhattisgarh" },
      { code: "GA", name: "Goa" },
      { code: "GJ", name: "Gujarat" },
      { code: "HR", name: "Haryana" },
      { code: "HP", name: "Himachal Pradesh" },
      { code: "JH", name: "Jharkhand" },
      { code: "KA", name: "Karnataka" },
      { code: "KL", name: "Kerala" },
      { code: "MP", name: "Madhya Pradesh" },
      { code: "MH", name: "Maharashtra" },
      { code: "MN", name: "Manipur" },
      { code: "ML", name: "Meghalaya" },
      { code: "MZ", name: "Mizoram" },
      { code: "NL", name: "Nagaland" },
      { code: "OD", name: "Odisha" },
      { code: "PB", name: "Punjab" },
      { code: "RJ", name: "Rajasthan" },
      { code: "SK", name: "Sikkim" },
      { code: "TN", name: "Tamil Nadu" },
      { code: "TG", name: "Telangana" },
      { code: "TR", name: "Tripura" },
      { code: "UP", name: "Uttar Pradesh" },
      { code: "UK", name: "Uttarakhand" },
      { code: "WB", name: "West Bengal" }
    ];
    
    console.log(states);
    
    this.tableDataForLoca = states;
    this.getLocationListForPrifix();
  }


  depateMentCode: any
  editIndex: any;
  addDeptCode(data: any) {
    console.log(data);

    this.depateMentCode = data;
  }
  saveBand(index: any) {


    let formData = {
      "hrId": this.loggedInUserId,
      "companyId": this.loggedInUserCompanyID,
      "departmentName": this.depateMentCode?.department, // add trim from frondend too 
      "departmentPrefix": this.depateMentCode?.deptCode,
      "year": this.year ? this.year : this.yearForNewDept,
      "companyCodeId": this.employeeDetails.companyCodeId ? this.employeeDetails.companyCodeId : this.companyCodeId
    }
    let updateFromData = {
      "hrId": this.loggedInUserId,
      "companyId": this.loggedInUserCompanyID,
      "departmentName": this.depateMentCode?.department, // add trim from frondend too 
      "departmentPrefix": this.depateMentCode?.deptCode,
      "year": this.year ? this.year : this.yearForNewDept,
      "companyCodeId": this.employeeDetails.companyCodeId ? this.employeeDetails.companyCodeId : this.companyCodeId
    }
    if (this.depateMentCode.departmentId == null) {
      this.httpService.callPostService(`${this.config.addDepartment}`, formData).subscribe((data: any) => {


        if (data) {

          // Success popup
          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: data.message,
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });

          // Handle the result of the dialog
          dialogRef.afterClosed().subscribe(() => {
            if( this.popupName.label){
              this.dialogRef.close();
            }
            this.getDeptList();
          });
          this.onCheckIconView = false;
          this.isFormDisabled = true;
          this.editableIndex = null
        }
      },
        (error: any) => {

          const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: error.error.error || 'An error occurred while processing your request. Please try again.',
              btn2: 'OK',
              btn2BgColor: 'red', // Highlight error with red button color
              showSuccessIcon: false,
              showSuccessMessage: false,
              showCloseIcon: true
            }
          });

          errorDialogRef.afterClosed().subscribe(() => {
            // Optionally handle any action after closing the error dialog
            console.log('Error dialog closed');
          });
        }
      );
    } else {
      if(this.depateMentCode==undefined ||this.depateMentCode==null){
        const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: 'Band updated successfully',
            btn2: 'OK',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: true,
            showSuccessMessage: false,
            showCloseIcon: false
          }
        });

        // Handle the result of the dialog
        dialogRef.afterClosed().subscribe(() => {
          this.getDeptList();
        });
        this.onCheckIconView = false;
        this.isFormDisabled = true;
        this.editableIndex = null
        return
      }

      this.httpService.callPutService(`${this.config.updateDepartment}/${this.depateMentCode.departmentId}`, updateFromData).subscribe((data: any) => {


        if (data) {

          // Success popup
          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: data.message,
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });

          // Handle the result of the dialog
          dialogRef.afterClosed().subscribe(() => {
            this.getDeptList();
          });
          this.onCheckIconView = false;
          this.isFormDisabled = true;
          this.editableIndex = null
        }
      },
        (error: any) => {

          const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: error.error.error || 'An error occurred while processing your request. Please try again.',
              btn2: 'OK',
              btn2BgColor: 'red', // Highlight error with red button color
              showSuccessIcon: false,
              showSuccessMessage: false,
              showCloseIcon: true
            }
          });

          errorDialogRef.afterClosed().subscribe(() => {
            // Optionally handle any action after closing the error dialog
            console.log('Error dialog closed');
          });
        }
      );
    }
  }

  isUpdateInProgress: boolean = false;  // ✅ Declare the flag
saveLocation() {
 
    
this.invalidLocation = this.updatetableDataForLoca.some((loc: any) => loc.locationId == null);
 
    
  if (this.depateMentCode==undefined&&this.invalidLocation) {
    const requests = this.tableDataForLoca.map((elm: any) => {
      let formData = {
        "hrId": this.loggedInUserId,
        "companyId": this.loggedInUserCompanyID,
        "locationName": elm.name.trim(),  // Trim added
        "locationPrefix": elm.code,
        "year": this.year,
        "companyCodeId": this.employeeDetails.companyCodeId ? this.employeeDetails.companyCodeId : this.companyCodeId
      };
    
      return this.httpService.callPostService(`${this.config.addLocation}`, formData);
    });
    
    // Execute all API calls in parallel
    forkJoin(requests).subscribe(
      (responses: any) => {
        // Success: API calls completed
        console.log('All locations added successfully:', responses);
        
        // Fetch updated list only once after all are completed
        this.getLocationListForPrifix();
      },
      (error: any) => {
        // Handle error
        this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: error.error?.error || 'An error occurred while processing your request. Please try again.',
            btn2: 'OK',
            btn2BgColor: 'red',
            showSuccessIcon: false,
            showSuccessMessage: false,
            showCloseIcon: true
          }
        }).afterClosed().subscribe(() => {
          console.log('Error dialog closed');
        });
      }
    );
    }
  }


  updateLocation(){

    
      console.log(this.depateMentCode);
      if(this.depateMentCode==undefined){
        const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: 'Location updated successfully',
            btn2: 'OK',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: true,
            showSuccessMessage: false,
            showCloseIcon: false
          }
        });

        // Handle the result of the dialog
        dialogRef.afterClosed().subscribe(() => {
          this.getLocationListForPrifix();
        });
        this.onCheckIconView = false;
        this.isFormDisabled = true;
        this.editableIndex = null
        return
      }
      
      let updateFromData = {
        "hrId": this.loggedInUserId,
        "companyId": this.loggedInUserCompanyID,
        "locationName": this.depateMentCode?.name,  // add trim from frondend too 
        "locationPrefix": this.depateMentCode?.code,
        "year": this.year,
        "companyCodeId": this.employeeDetails?.companyCodeId ? this.employeeDetails?.companyCodeId : this.companyCodeId
      }
      this.httpService.callPutService(`${this.config.updateLocation}/${this.depateMentCode?.locationId}`, updateFromData).subscribe((data: any) => {
     if (data) {

          // Success popup
          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: data.message,
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });

          // Handle the result of the dialog
          dialogRef.afterClosed().subscribe(() => {
            this.getLocationListForPrifix();
          });
          this.onCheckIconView = false;
          this.isFormDisabled = true;
          this.editableIndex = null
        }
      },
        (error: any) => {

          const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: error.error.error || 'An error occurred while processing your request. Please try again.',
              btn2: 'OK',
              btn2BgColor: 'red', // Highlight error with red button color
              showSuccessIcon: false,
              showSuccessMessage: false,
              showCloseIcon: true
            }
          });

          errorDialogRef.afterClosed().subscribe(() => {
            // Optionally handle any action after closing the error dialog
            console.log('Error dialog closed');
          });
        }
      );
    }
  
   
  
  
}
